// Cardiac subsection questionnaire constants
export enum CardiacQuestionnaireItem {
  MEDICAL_BACKGROUND_CARDIAC = 'medical-background/cardiac',
  MEDICAL_BACKGROUND_CARDIAC_CARDIOVASCULAR_WNL = 'medical-background/cardiac/cardiovascular-wnl',
  MEDICAL_BACKGROUND_CARDIAC_CARDIOVASCULAR_FACTORS = 'medical-background/cardiac/cardiac-factors',
  MEDICAL_BACKGROUND_CARDIAC_HEART_SOUNDS = 'medical-background/cardiac/heart-sounds',
  MEDICAL_BACKGROUND_CARDIAC_SYSTEM_SUMMARY = 'medical-background/cardiac/system-summary'
}
